import React from "react";

export type SizeIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 24,
    height: 24,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 24,
    height: 24,
  },
};

export const SizeIcon = React.forwardRef<SVGSVGElement, SizeIconProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "#E01B3F" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9168 1.2C11.7546 1.21969 11.6037 1.29375 11.4893 1.41L8.60935 4.29C8.46029 4.42219 8.3731 4.60968 8.36748 4.80845C8.36185 5.0072 8.43872 5.19939 8.57935 5.34C8.72091 5.47969 8.91403 5.55563 9.1128 5.54813C9.31155 5.54157 9.49812 5.4525 9.62935 5.30251L11.2793 3.65251V20.34L9.62935 18.69C9.4756 18.5306 9.25716 18.45 9.03684 18.4725C8.76029 18.5025 8.52497 18.689 8.43309 18.9525C8.34216 19.215 8.41059 19.5075 8.60935 19.7025L11.4893 22.5825C11.6243 22.7184 11.8081 22.7943 11.9993 22.7943C12.1906 22.7943 12.3743 22.7184 12.5093 22.5825L15.3893 19.7025C15.5384 19.5703 15.6256 19.3828 15.6312 19.184C15.6368 18.9853 15.56 18.7931 15.4193 18.6525C15.2778 18.5128 15.0847 18.4368 14.8859 18.4443C14.6871 18.4509 14.5006 18.54 14.3693 18.6899L12.7193 20.3399V3.6525L14.3693 5.3025C14.5006 5.4525 14.6871 5.54157 14.8859 5.54812C15.0846 5.55562 15.2778 5.47968 15.4193 5.33999C15.56 5.19937 15.6368 5.00719 15.6312 4.80844C15.6256 4.60969 15.5384 4.42219 15.3893 4.28999L12.5093 1.40999C12.3547 1.25249 12.1362 1.17562 11.9168 1.19999L11.9168 1.2Z"
          fill={color}
        />
      </svg>
    );
  }
);

SizeIcon.displayName = "SizeIcon";
